import { HttpErrorResponse } from "@angular/common/http";
import { createAction, props } from "@ngrx/store";
import { AssignedOrganisation } from "src/app/_models/Organisation";
import { CentreTransferRequestDTO, OrganisationTransferRequestDTO, SubmitTransferResponse } from "src/app/_models/TransferLearner";
import { Userprofile } from "src/app/_models/Userprofile";
import { TransferLearnerActionTypes } from "src/app/constants/StoreConstants";

export const SubmitTransferRequest = createAction(
  TransferLearnerActionTypes.SubmitTransferRequest,
  props<{request: OrganisationTransferRequestDTO}>()
);

export const SubmitTransferRequestSuccess = createAction(
  TransferLearnerActionTypes.SubmitTransferRequestSuccess,
  props<{response: SubmitTransferResponse}>()
);

export const SubmitTransferRequestError = createAction(
  TransferLearnerActionTypes.SubmitTransferRequestError,
  props<{error: HttpErrorResponse}>()
);

export const FindLearnerDetails = createAction(
  TransferLearnerActionTypes.FindLearnerDetails,
  props<{usernameOrEmail: string}>()
);

export const FindLearnerDetailsSuccess = createAction(
  TransferLearnerActionTypes.FindLearnerDetailsSuccess,
  props<{response: Userprofile}>()
);

export const FindLearnerDetailsError = createAction(
  TransferLearnerActionTypes.FindLearnerDetailsError,
  props<{error: HttpErrorResponse}>()
);

export const GetAssignedOrganisation = createAction(
  TransferLearnerActionTypes.GetAssignedOrganisation
);

export const GetAssignedOrganisationSuccess = createAction(
  TransferLearnerActionTypes.GetAssignedOrganisationSuccess,
  props<{response: AssignedOrganisation[]}>()
);

export const GetAssignedOrganisationError = createAction(
  TransferLearnerActionTypes.GetAssignedOrganisationError,
  props<{error: HttpErrorResponse}>()
);

export const ResetTransferLearnerState = createAction(
  TransferLearnerActionTypes.ResetTransferLearnerState
);

export const StartTransfer = createAction(
  TransferLearnerActionTypes.StartTransfer
);

export const StartTransferSuccess = createAction(
  TransferLearnerActionTypes.StartTransferSuccess,
  props<{result: boolean}>()
);

export const StartTransferError = createAction(
  TransferLearnerActionTypes.StartTransferError,
  props<{error: HttpErrorResponse}>()
);

export const UndoTransfer = createAction(
  TransferLearnerActionTypes.UndoTransfer,
  props<{transferId: number}>()
);

export const UndoTransferSuccess = createAction(
  TransferLearnerActionTypes.UndoTransferSuccess,
  props<{result: boolean}>()
);

export const UndoTransferError = createAction(
  TransferLearnerActionTypes.UndoTransferError,
  props<{error: HttpErrorResponse}>()
);

export const SubmitTransferCentreRequest = createAction(
  TransferLearnerActionTypes.SubmitTransferCentreRequest,
  props<{request: CentreTransferRequestDTO}>()
);

export const SubmitTransferCentreRequestSuccess = createAction(
  TransferLearnerActionTypes.SubmitTransferRequestCentreSuccess,
  props<{response: SubmitTransferResponse}>()
);

export const SubmitTransferCentreRequestError = createAction(
  TransferLearnerActionTypes.SubmitTransferRequestCentreError,
  props<{error: HttpErrorResponse}>()
);